import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navigation from 'blocks/Navigation';
import NavigationAwarePageContent from 'blocks/NavigationAwarePageContent';
import root from 'window-or-global';
import Regulations from 'blocks/Regulations';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../stores/App.store';
import InjectMetaTags from 'blocks/InjectMetaTags';

@inject('appStore', 'coreStore')
@observer
class RegulationsPage extends Component {
  componentDidMount() {
    root.scrollTo(0, 0);
  }

  componentDidUpdate() {
    root.scrollTo(0, 0);
  }

  render() {
    const {
      isAppRegulations,
      coreStore: { content: { termsOfUseSEO, appRegulationsSEO } }
    } = this.props;

    const SEO = isAppRegulations ? appRegulationsSEO : termsOfUseSEO;

    return (
      <React.Fragment>
        <InjectMetaTags {...SEO} />
        <Navigation />
        <NavigationAwarePageContent>
          <Regulations isAppRegulations={isAppRegulations} />
        </NavigationAwarePageContent>
      </React.Fragment>
    );
  }
}

RegulationsPage.propTypes = {
  appStore: PropTypes.instanceOf(AppStore).isRequired,
  isAppRegulations: PropTypes.bool,
};

RegulationsPage.defaultProps = {
  isAppRegulations: false,
};

export const AppRegulations = props => (
  <RegulationsPage isAppRegulations {...props} />
);
export default RegulationsPage;



// WEBPACK FOOTER //
// ./src/pages/Regulations/index.jsx